import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JSONRpc } from '../service-jsonrpc';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class dossierValuesService {
    constructor(
        private http: HttpClient
    ) {}
    
    callPOSTJSONRpc(url, rpcMethod): Observable<any> {
        return this.http.post<JSONRpc>(url + '?' + rpcMethod.method, rpcMethod);
    }
    
    rapportComparateur(dossiers): Observable<any> {
        let rpcMethod = new JSONRpc({
            jsonrpc: "2.0",
            method: "webservice.dossier:rapportComparateur",
            params: {
                dossiers : dossiers,
            }
        });
        return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
    }
}